import { Typography } from '@material-ui/core';
import { useStyles } from './listPickerSettingsDialog.style';
import { useTheme } from '@material-ui/core/styles';

import { Table, TableColumn } from '@backstage/core-components';
import { useEffect, useState } from 'react';

const columns: TableColumn<{ name: string }>[] = [
  { title: 'Name of the team', field: 'name' },
];

interface ListPickerSettingsDialogProps {
  formData: string | null;
  onChange: (value: string) => void;
  schema: { enum: string[] } | null;
}

function ListPickerSettingsDialog({
  formData,
  onChange,
  schema,
}: ListPickerSettingsDialogProps) {
  const { cx, classes } = useStyles();
  const theme = useTheme();

  const generateRows = (enumValues: string[]) =>
    enumValues.map((item, index) => ({ name: item, index }));

  const rows = schema?.enum ? generateRows(schema.enum) : [];
  const [selectedItem, setSelectedItem] = useState<string | null>(
    formData || null,
  );

  useEffect(() => {
    setSelectedItem(formData || null);
  }, [formData]);

  if (!schema?.enum) return <Typography>No items available</Typography>;

  const handleRowClick = (rowData: { name: string }) => {
    setSelectedItem(rowData.name);
    onChange(rowData.name);
  };

  return (
    <div className={cx(classes.table)}>
      <Table
        options={{
          search: true,
          paging: false,
          rowStyle: rowData => {
            let backgroundColor;
            let textColor = 'inherit';

            if (rowData.name === selectedItem) {
              backgroundColor = theme.palette.primary.main;
              textColor = theme.palette.common.white;
            } else if (rowData.index % 2 === 0) {
              backgroundColor = theme.palette.background.paper;
            } else {
              backgroundColor = theme.palette.action.hover;
            }

            return { backgroundColor, color: textColor };
          },
        }}
        columns={columns}
        data={rows}
        onRowClick={(_, rowData) => rowData && handleRowClick(rowData)}
      />
    </div>
  );
}

export { ListPickerSettingsDialog };
